import * as React from "react";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { fetchKitRegistrationsForUser } from "../utility";
import { fetchSubmissionsForKitRegistration, fetchSubmissionStatus, downloadProjectResults } from "../utility";
import {FaFileDownload} from 'react-icons/fa';
import {FaUpload} from 'react-icons/fa';
import {AiFillFolderAdd} from 'react-icons/ai';
import ReactDOMServer from 'react-dom/server';


const faFileDownloadHTML = ReactDOMServer.renderToString(
    <FaFileDownload />
)

const faUploadHTML = ReactDOMServer.renderToString(
    <FaUpload className="mx-1" style={{verticalAlign: 'sub'}}/>
)

const aiFillFolderAddHTML = ReactDOMServer.renderToString(
    <AiFillFolderAdd />
)

export default function DashboardTable(props) {

    React.useEffect(() => {
        console.log("From DashboardTable.jsx", props.prop1)

        fetchKitRegistrationsForUser()
        .then((data) => {
            console.log(data)
            renderTable(data, "submissions-table");
        })


    }, []);


    return (
        <div className="w-100 d-flex flex-column">
            <div className="table-light" id="submissions-table" />
        </div>
    )
}




function renderTable(data, divId) {

    let tableEle = document.getElementById(divId);
    let table = new Tabulator(tableEle, {
        // height:"100%",
        // responsiveLayout:"collapse",
        renderVertical:"basic",
        layout:"fitColumns",
        columnDefaults:{
            // resizable:false,
        },
        data:data,
        columns:[
            { 
                title:"Project ID", 
                field:"project_id", 
                visible: true, 
                responsive: true,
                sorter: "number",
                headerFilter: "input",
                headerFilterPlaceholder: "Search by project id...",
                cssClass:"project-name-column",
            },
            {
                title:"Project Name", 
                field:"project_name", 
                responsive: true, 
                headerFilter:"input", 
                headerFilterPlaceholder:"Search by project name...", 
                headerFilterFunc:"like", 
                cssClass:"project-name-column",
                sorter: "string",
            },
            { 
                title:"Kit ID", 
                field:"kit_registration_id", 
                visible: true, 
                responsive: true, 
                cssClass:"project-name-column",
                sorter: "number",
                headerFilter: "input",
                headerFilterPlaceholder: "Search by kit registration id...",
            },
            {
                title: "Kit Name",
                field: "kit_name",
                responsive: true,
                headerFilter: "input",
                headerFilterPlaceholder: "Search by kit name...",
                headerFilterFunc: "like",
                cssClass: "project-name-column",
                sorter: "string",
            },
            {
                title: "Instrument",
                field: "instrument",
                responsive: true,
                headerFilter: "input",
                headerFilterPlaceholder: "Search by instrument...",
                headerFilterFunc: "like",
                cssClass: "project-name-column",
                sorter: "string",
            },
            {
                title:"Assay",
                field:"assay",
                responsive: true,
                headerFilter:"input",
                headerFilterPlaceholder:"Search by assay...",
                headerFilterFunc:"like",
                cssClass:"project-name-column",
                sorter: "string",
            },
            {
                title:"Biofluid",
                field:"biofluid",
                responsive: true,
                headerFilter:"input",
                headerFilterPlaceholder:"Search by biofluid...",
                headerFilterFunc:"like",
                cssClass:"project-name-column",
                sorter: "string",
            },
            {
                title:"Date Created",
                field:"date_created",
                responsive: true,
                headerFilter:"input",
                headerFilterPlaceholder:"Search by date created...",
                headerFilterFunc:"like",
                cssClass:"project-name-column",
                hozAlign:"start",
                vertAlign:"middle",
                // width: 320,
                sorter: "date",
                sorterParams: {
                    format: "MM/DD/YYYY",
                },
                //TODO: sort by date, make sure you add the correct sorterParams date format as well
            },
            {
                title:"Date Updated",
                field:"date_updated",
                responsive: true,
                headerFilter:"input",
                headerFilterPlaceholder:"Search by date updated...",
                headerFilterFunc:"like",
                cssClass:"project-name-column",
                hozAlign:"start",
                vertAlign:"middle",
                // width: 320,
                sorter: "date",
                sorterParams: {
                    format: "MM/DD/YYYY",
                },
                visible: false,
            },
            {
                title:"Actions",
                formatter:kitActionButtons,
                hozAlign:"center",
                responsive: true,
                cssClass:"kit-name-column",
                width: 300,
            }
        ],
    });

}


let kitActionButtons = function(cell, formatterParams, onRendered) {
    let uploadFilesHref = window.location.origin + "/submissions/new?project_id=" + cell.getRow().getData().project_id + "&kit_registration_id=" + cell.getRow().getData().kit_registration_id
    let viewKitRegistrationHref = '/kit_registrations/' + cell.getRow().getData().kit_registration_id
    let html = `
        <div class="btn-group w-100">
            <button class='btn btn-dark btn-outline-light' style="width: 40%; background-color:green" onClick="window.location='${viewKitRegistrationHref}'">View</button>
        </div>
    `
    return html;
}